import { css } from '@emotion/css'
import React from 'react'

const STYLES_TAB_CONTAINER = css`
  border-radius: 6px;
`
const STYLES_TAB_CONTENT = css`
  padding: 20px;
  background-color: #faf8fb;
`

const STYLES_TAB_LIST = css`
  border-bottom: 1px solid #ccc;
  padding-left: 0;
`

const STYLES_TAB_LIST_ITEM = css`
  display: inline-block;
  position: relative;
  color: #000;
  min-width: 150px;
  list-style: none;
  text-align: center;
  margin-bottom: -1px;
  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  :hover {
    cursor: pointer;
  }
  font-family: 'PayPalOpen-Regular', 'PayPal Sans Big', 'Helvetica Neue', Arial,
    sans-serif;
  font-weight: 500;
`

const STYLES_TAB_LIST_ACTIVE = css`
  background-color: white;
  background: #faf8fb;
  color: #0070ba;
  border-radius: 4px;
  &:after {
    position: absolute;
    content: '';
    height: 3px;
    bottom: -8px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 100%;
    background: #0070ba;
    -o-transition: 0.5s;
    -ms-transition: 0.5s;
    -moz-transition: 0.5s;
    -webkit-transition: 0.5s;
    transition: 0.5s;
  }
`

const STYLES_TAB_ANCHOR_CONTENT = css`
  padding: 8px 40px;
  border-radius: 4px;
  color: rgb(0, 112, 186);
  color: #000;
  :hover {
    text-decoration: none;
    color: #000;
  }
  :focus {
    text-decoration: none;
  }
`
const STYLES_TAB_ANCHOR_CONTENT_ACTIVE = css`
  color: #0070ba;
  :hover {
    color: #0070ba;
  }
  :focus {
    color: #0070ba;
  }
`
const TabButtonLight = ({ activeTab, label, hashLink, onClick }: any) => {
  const handleClick = () => onClick(label)

  const classNames = [STYLES_TAB_LIST_ITEM]
  const achhorClassNames = [STYLES_TAB_ANCHOR_CONTENT]

  if (activeTab === label) {
    classNames.push(STYLES_TAB_LIST_ACTIVE)
    achhorClassNames.push(STYLES_TAB_ANCHOR_CONTENT_ACTIVE)
  }

  return (
    <li className={classNames.join(' ')} onClick={handleClick} id={label}>
      {hashLink === 'active' ? (
        <a
          className={achhorClassNames.join(' ')}
          href={`#${label.toLowerCase().replaceAll(' ', '-')}`}
          rel="noreferrer"
        >
          {label}
        </a>
      ) : (
        label
      )}
    </li>
  )
}

/**
 * Dummy emelent, needed for `<Tabs/>` component to work properly
 */
export const ContentTab = ({ children }: any) => children

/**
 * @example
 * <Tabs>
 *   <Tab label="Tab1">Tab 1 content...</Tab>
 *   <Tab label="Tab2">Tab 2 content...</Tab>
 * </Tabs>
 */
export const ContentTabs = ({ children }: any, props: any) => {
  const hashValue =
    (typeof window !== 'undefined' && window.location?.hash?.toLowerCase()) ||
    ''
  let activeTabValue = children[0].props.label

  if (children.length > 1 && hashValue) {
    activeTabValue =
      children.find((data) => {
        return (
          `#${data.props.label.toLowerCase().replaceAll(' ', '-')}` ===
            hashValue && data.props?.hashLink.toLowerCase() === 'active'
        )
      })?.props?.label || children[0].props.label
  }
  const [activeTab, setActiveTab] = React.useState(activeTabValue)

  return (
    <div
      className={STYLES_TAB_CONTAINER + ' newTabs-container-light'}
      id={hashValue?.replace('#', '') || 'newTabs-container-light'}
    >
      <ol className={STYLES_TAB_LIST + ' newTabs-orderedList-light'}>
        {children.map(
          (child: {
            props: { label: string; hashLink: 'active' | 'inActive' }
          }) => {
            const { label, hashLink = 'inActive' } = child.props
            return (
              <TabButtonLight
                id={label}
                activeTab={activeTab}
                key={label}
                label={label}
                hashLink={hashLink.toLowerCase()}
                onClick={setActiveTab}
              />
            )
          },
        )}
      </ol>
      <div className={STYLES_TAB_CONTENT}>
        {children.map((child: { props: { label: any; children: any } }) => {
          if (child.props.label !== activeTab) {
            return
          }
          return child.props.children
        })}
      </div>
    </div>
  )
}
